export const T = {
  en_GB: {
    submitted: "Submitted",
    pdf_generated: "PDF",
    compliance_review: "Compliance",
    external_review: "External approval",
    signing: "Signing",
    completed: "Completed",
    cancelled: "Cancelled",
  },
  nb_NO: {
    submitted: "Innsendt",
    pdf_generated: "PDF",
    compliance_review: "Compliance",
    external_review: "Ekstern godkjenning",
    signing: "Signering",
    completed: "Fullført",
    cancelled: "Kansellert",
  },
} as const;
